import request from '@/utils/request'

/**
 * 获取组织列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listOrgs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chooseOrg/list',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}